import React from 'react';

const STYLES = {
  issued: 'bg-accent-soft text-ink',
  signed: 'bg-success-soft text-success',
  withdrawn: 'bg-cream text-muted',
  pending: 'bg-accent-soft text-ink',
  delivered: 'bg-success-soft text-success',
  failed: 'bg-danger-soft text-danger',
};
const LABELS = { issued: 'Awaiting signature' };

const StatusBadge = ({ status }) => (
  <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${STYLES[status] || 'bg-cream text-muted'}`}>
    {LABELS[status] || status}
  </span>
);

export default StatusBadge;
